'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'file-certificate';
var width = 512;
var height = 512;
var aliases = ["file-award"];
var unicode = 'f5f3';
var svgPathData = 'M247.4 338.3c7.5-7.5 10.37-18.5 7.625-28.75c-5.375-20.62-5.5-17.75 0-38.38c2.748-10.38-.125-21.38-7.625-28.88C232.5 227.1 233.1 229.6 228.5 209C225.9 198.8 217.1 190.8 207.9 188C187.5 182.4 190 183.9 175.1 168.8C167.8 161.3 156.1 158.3 146.9 161c-20.37 5.5-17.49 5.5-37.74 0C99.01 158.3 88.26 161.3 80.89 168.8C65.89 183.9 68.39 182.4 48.14 188C38.02 190.8 30.23 198.8 27.48 209c-5.375 20.75-4 18.12-18.87 33.25c-7.375 7.5-10.33 18.5-7.582 28.88c5.375 20.62 5.375 17.75 0 38.38c-2.75 10.25 .207 21.25 7.582 28.75c14.87 15.12 13.5 12.62 18.87 33.25c2.75 10.38 10.54 18.38 20.67 21.12c14.37 3.875 11.5 3 15.87 5V512l63.99-32l63.99 32v-114.4c4.25-2 1.499-1.125 15.87-5c9.998-2.75 17.1-10.75 20.62-21.12C233.1 350.8 232.5 353.4 247.4 338.3zM128 352c-35.37 0-63.99-28.62-63.99-64S92.64 224 128 224s63.99 28.62 63.99 64S163.4 352 128 352zM493.3 93.38l-74.63-74.64C406.6 6.742 390.3 0 373.4 0L191.1-.0001c-35.35 0-64 28.65-64 64l.0105 68.94c0 0 22.02-10.7 48-.7539L176 64.13c0-8.836 7.164-16 16-16h160L352 128c0 17.67 14.33 32 32 32h79.1v288c0 8.836-7.164 16-16 16H224L223.1 512l224-.0001c35.2 0 64-28.8 64-64V138.6C512 121.7 505.3 105.4 493.3 93.38z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileCertificate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;